import { IsiDtoPlXmlUserSettingsRequest, IsiDtoPlXmlUserSettingsResponse, IsiDtoPlXmlUserSettingsResult } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlXmlUserSettings";
import { IIsiUIFlowResultGeneric } from "../Core/IIsiUIFlowResultGeneric";
import { IsiPresentationLogic } from "./IsiPresentationLogic";

export class IsiPlXmlUserSettings extends IsiPresentationLogic {

    constructor() {
        super("IsiPlXmlUserSettingsHandler");
    }

    /**
    * Traitement pour calculer toutes les valdef en un appel
    * */
    public async GetXmlUserSettings(xmlType: string, actions: string): Promise<IsiDtoPlXmlUserSettingsResult> {

        const params = IsiDtoPlXmlUserSettingsRequest.fromJS({
            xmlType: xmlType,
            actions: actions,

            response: IsiDtoPlXmlUserSettingsResponse.fromJS({})
        });
        const result: IIsiUIFlowResultGeneric<IsiDtoPlXmlUserSettingsRequest> = await this.ajaxWithErrorHandling("GetXmlUserSettings", params, true);
        const dto = result?.reponse?.response?.result;


        return dto;

    }

    /**
     * Traitement pour calculer la valdef d'un seul élément discret
     * */
    public async GetDiscretXmlUserSettings(
        xmlType: string,
        linkedCtrlValues: string,
        xmlClientCtrlId: string,
        xmlClientTriggerId: string,
        xmlClientCtrlValue: string): Promise<IsiDtoPlXmlUserSettingsResult> {

        const params = IsiDtoPlXmlUserSettingsRequest.fromJS({
            xmlType: xmlType,
          
            xmlClientCtrlValues: linkedCtrlValues,
            xmlClientCtrlId: xmlClientCtrlId,
            xmlClientTriggerId: xmlClientTriggerId,
            xmlClientCtrlValue: xmlClientCtrlValue,
            response: IsiDtoPlXmlUserSettingsResponse.fromJS({})
        });
        const result: IIsiUIFlowResultGeneric<IsiDtoPlXmlUserSettingsRequest> = await this.ajaxWithErrorHandling("GetXmlUserSettings", params, true);
        const dto = result?.reponse?.response?.result;

        return dto;

    }

   

}
